import { Toast, Modal } from "@douyinfe/semi-ui";
import { bytesToKb, filterObj } from "../utils";
import { CrudOption } from "../comp/crud";
import { FileItem } from "@douyinfe/semi-ui/lib/es/upload";
import { Client, messageCallbackType } from "@stomp/stompjs";

export const ORDER_TITLE = "orderTitle";
export const ORDER_DESCRIPTION = "orderDescription";
export const LOAN_TITLE = "loanTitle";
export const LOAN_DESCRIPTION = "loanDescription";
const PREF_KEY = "userPref";
const PORT = "8080";//端口号 生产环境是 8080 测试环境是3000


function getEndpoint(): string {
  if (isLocal()) {
    return "http://127.0.0.1:" + PORT + "/api/mis";
  } else {
    return "/api/mis";
  }
}

function getWsEndpoint(): string {
  if (isLocal()) {
    return "ws://127.0.0.1:" + PORT + "/ws";
  } else {
    //var protocol = window.location.protocol == "https:" ? "wss:" : "ws:";
    var protocol =  "ws:";
    if (location.host.indexOf(PORT) > 0) {
      return protocol + "//" + location.host + "/ws";
    } else {
      return protocol + "//" + location.host + ":" + PORT + "/ws";
    }
  }
}

export interface BaseModel {
  id: number;
}

const DICT: Record<string, string[]> = {};

export interface ApiResp<T> {
  code: string;
  msg: string;
  data: T;
}
export interface Req { }
export interface Attachment {
  id: number;
  loanId: number;
  filename: string;
  size: number;
  field: string;
}
export interface RecentInputResult {
  type: string;
  inputs: string[];
}

export interface CsAgent extends BaseModel {
  name: string;
}

export interface ApiDocInfo {
  username: string;
  password: string;
  url: string;
}

export interface LeadContactLog extends BaseModel {
  saleId: number;
  saleName: string;
  content: string;
  createdAt: string;
}

export interface LeadStarLog extends BaseModel {
  saleName: string;
  star: number;
  lastStar: number;
  status: LeadStatus;
  createdAt: string;
  remark: string;
}

export interface LeadAssignLog extends BaseModel {
  assignBy: string;
  saleName: string;
  remark: string;
  createdAt: string;
}

export interface LeadVisitAssignLog extends BaseModel {
  saleName: string;
  createdAt: string;
  confirmAt: string;
}

export interface LoanLog extends BaseModel {
  userName: string;
  content: string;
  status: string;
  createdAt: string;
}

export interface LoanContactLog extends BaseModel {
  userName: string;
  content: string;
  todoType: string;
  createdAt: string;
  createdByName: string;
}

export interface Team extends BaseModel {
  name: string;
  city: string;
  parentId: number;
  parentName: string;
  twoStarsHours: string;
  pendingVisitHours: string;
  visitedHours: string;
  signedContractHours: string;
  reviewingHours: string;
  payoutHours: string;
  rejectedHours: string;
  paidHours: string;
  userNames: string;
}

export interface Lead extends BaseModel {
  leadId: number;
  nowLeadId: number;
  leadNo: string;
  loanType: string;
  score: number;
  teamId: number;
  teamName: string;
  rootTeamId: number;
  rootTeamName: string;
  saleId: number;
  saleName: number;
  managerId: number;
  managerName: string;
  rootManagerId: number;
  rootManagerName: string;

  name: string;
  fullMobile: string;
  applyAmount: number;
  star: number;
  age: number;
  source: string;
  platform: string;
  ipCity: string;
  ip: string;
  gender: string;
  job: string;
  house: string;
  income: string;
  vehicle: string;
  assurance: string;
  providentFund: string;

  socialSecurity: string;
  company: string;
  credit: string;
  marriage: string;
  remark: string;
  cost: number;
  status: LeadStatus;
  assignStatus: LeadAssignStatus;
  signedContractAt: string;
  paidReturnAt: string;
  sentToPoolAt: string;
  actVisitTimeNew: string;
  fav: boolean;
  leadType: LeadType;
  loanAt: string;
  companyName: string;
  loanPoint: string;
  salaryBankName: string;
  salary: string;
  providentFundBasic: string;
  education: string;
  loanStatus: string;
  settledLoanAt: string;
  interest: number;
  commission: number;
  settledLoanOperator: string;
  content: string;
  estVisitTime: string;
  userAgreement: string;
  applyCity: string;
  intentionLevel?: string;
  intentionTags?: string[];
  resistancePoints?: string[];
  scoredAt?: string;
  aiConclusion?: string;
}

export interface LeadMsg {
  sentToPoolAt: string;
  assignCount: number;
  name: string;
  msgType?: string;
}

export interface TodoMsg {
  todoMsgType: number;
  todoCount: number;
  content: string;
  dueDate: string;
}

export interface Todo {
  id: number;
  content: string;
  dueDate: string;
  done: boolean;
}

export interface Loan extends BaseModel {
  id: number;
  attachments: FileItem[];
  status: LoanStatus;
  auditingStatus: LoanAuditingStatus;
  leadId: number;
  leadName: string;
  createdAt: string;
  leadRelationLeadCreateReq: LeadRelationLeadCreateReq;
}

export interface AppVersion {
  publishType: string;
  appQrcodeUrl: string; //升级包地址
  forceUpdate: string; //是否强制热更新
  updateIntro: string; //升级包提示
  appVersion: string; //升级包版本
  appDownloadUrl: string; //升级包地址
  wgtVersion: string; //热更新版本号
  wgtDownloadUrl: string; //热更新地址
}

export interface LeadRelationLeadCreateReq {
  loanId: number;
  mainLeadId: number;
  mainLeadName: string;
  mainLeadMobile: string;
  leadName: string;
  leadMobile: string;
  remark: string;
}

export interface UserLoanStatItem {
  users: number;
  authUsers: number;
  contactedCsUsers: number;
  loans: number;
  orders: number;
  paidOrders: number;
  offlinePaidOrders: number;
  paidAmount: number;
  offlinePaidAmount: number;
  statDate: string;
}


export interface CsStatItem extends BaseModel {
  csAgentName: string;
  users: number;
  contacts: number;
  orders: number;
  paidOrders: number;
  paidAmount: number;
  offlinePaidOrders: number;
  offlinePaidAmount: number;
  statDate: string;
}

export interface PayClient {
  key: string;
  payWebhookUrl: string;
  description: string;
  default: boolean;
}

export interface Config extends BaseModel {
  clientKey: string;
  key: string;
  value: string;
  description: string;
  options: ConfigOption[];
}

export interface UpdateConfig {
  id: number;
  value: string;
}

export interface ConfigOption {
  key: string;
  label: string;
}

export interface ClientConfig {
  defaultClient: Config;
  configs: Config[];
}

export interface CalResp {
  loanTerm: number;
  loanAmount: number;
  apr: number;
  interest: number;
  repayAmount: number;
  monthlyInterest: number;
  monthlyRepay: number;
}

export interface Page<T> {
  total: number;
  current: number;
  size: number;
  records: T[];
}

// ============ 客户触达分析 ============

export interface CustomerTouchStatReq {
  callAtStart?: string; // yyyy-MM-dd
  callAtEnd?: string;   // yyyy-MM-dd
  teamId?: number | null;
  saleIds?: number[] | null;
  customerType?: "new" | "old" | null;
}

export interface CustomerTouchSummary {
  // 维度一：分配触达
  totalAssigned: number;
  totalAssignedTouched: number;
  assignedTouchRate: number;
  newAssignedCount: number;
  newAssignedTouched: number;
  newAssignedTouchRate: number;
  oldAssignedCount: number;
  oldAssignedTouched: number;
  oldAssignedTouchRate: number;

  // 维度二：拨号有效触达
  dialedCount: number;
  effectiveDialedCount: number;
  effectiveDialedRate: number;
  newDialedCount: number;
  newEffectiveDialed: number;
  newEffectiveDialedRate: number;
  oldDialedCount: number;
  oldEffectiveDialed: number;
  oldEffectiveDialedRate: number;
}

export interface CustomerTouchRow {
  saleId: number;
  saleName: string;
  teamName: string;

  // 维度一：分配触达
  totalAssigned: number;
  totalAssignedTouched: number;
  assignedTouchRate: number;
  newAssignedCount: number;
  newAssignedTouched: number;
  newAssignedTouchRate: number;
  oldAssignedCount: number;
  oldAssignedTouched: number;
  oldAssignedTouchRate: number;

  // 维度二：拨号有效触达
  dialedCount: number;
  effectiveDialedCount: number;
  effectiveDialedRate: number;
  newDialedCount: number;
  newEffectiveDialed: number;
  newEffectiveDialedRate: number;
  oldDialedCount: number;
  oldEffectiveDialed: number;
  oldEffectiveDialedRate: number;
}

export interface CustomerTouchTeamOpt {
  id: number;
  name: string;
}

export interface CustomerTouchStatVO {
  summary: CustomerTouchSummary;
  rows: CustomerTouchRow[];
  teams: CustomerTouchTeamOpt[];
}

export interface CustomerTouchDetailVO {
  leadId: number;
  leadName: string;
  leadMobile: string;
  city: string;
  newLead: number; // 0=老客 1=新客
  newLeadLabel: string;
  saleId: number;
  saleName: string;
  teamName: string;
  callCount: number;
  connectedCount: number;   // call_time_long > 0
  unconnectedCount: number; // call_time_long 空或 <=0
  effectiveCount: number;
  avgCallDuration: number;
  touchRate: number;
}

export interface LeadCallLogItem {
  id: number;
  leadId: number;
  leadName: string;
  leadMobile: string;
  city: string;
  saleId: number;
  saleName: string;
  saleMobile: string;
  callAt: string;
  startAt: string;
  endAt: string;
  callTimeLong: number;
  recordFile: string;
  outRecordFile: string;
  recordName: string;
  recordUploaded: boolean;
  status: string;
  newLead: number;
  createdAt: string;
  updatedAt: string;
}

// ============ 通话统计 ============
export interface CallStatRow {
  saleId: number;
  saleName: string;
  teamName: string;
  contactCustomers: number; // 联系客户数
  callCount: number;        // 通话次数
  connectedCount: number;   // 接通次数（时长 > 0）
  unconnectedCount: number; // 未接通次数（时长空或 <= 0）
  effectiveCount: number;   // 有效通话（> 20 秒）
  totalDuration: number;    // 总时长（秒）
  avgDuration: number;      // 平均时长（秒）
  connectRate: number;      // 接通率 (%)
}

function buildCustomerTouchParams(
  req: CustomerTouchStatReq,
): Record<string, any> {
  const params: Record<string, any> = {};
  if (req.callAtStart && req.callAtEnd) {
    params.callAt = `${req.callAtStart},${req.callAtEnd}`;
  }
  if (req.teamId != null) params.teamId = req.teamId;
  if (req.saleIds && req.saleIds.length > 0) params.saleIds = req.saleIds;
  if (req.customerType) params.customerType = req.customerType;
  return params;
}

export interface LogInReq extends Req {
  mobile: string;
  password: string;
  captcha: string;
  otp: string;
}

export interface SwitchLogInReq extends Req {
  userId: number;
}

export interface ApiConfig extends BaseModel {
  category: string;
  code: string;
  name: string;
  client: string;
  value: string;
  valueDesc: string;
}

export function isLocal(): boolean {
  let host = window.location.host;
  return host.includes("localhost") || host.includes("127.0.0.1");
}
export interface Menu {
  code: string;
  name: string;
  icon: string;
  count: number;
  countTodo: number;
  menus: Menu[];
}
export interface User {
  id: number;
  csAgentId?: number;
  username: string;
  name: string;
  roleName: string;
  role: string;
  menus: Menu[];
  mobile: string;
  totp: string;
  managerId?: number;
  managerName: string;
  teamId: number;
  teamName: string;
  rootTeamId: number;
  rootTeamName: string;
  city: string;
}

export interface TeamManager {
  mainUserId: number;
  userId: number;
  name: string;
  roleName: string;
  teamId: number;
  teamName: string;
  city: string;
}

export interface Role {
  id: number;
  code: string;
  name: string;
}

export interface RoleGroup {
  id: number;
  key: string;
  name: string;
  roles: string[];
}

export interface SiteInfo {
  siteUrl: string;
  importTemplateUrl: string;
  termUrl: string;
  privacyUrl: string;
  otpLen: number;
  otpExpiresIn: number;
  skipOtp: number;
  menus: Menu[];
}

export interface TrafficApp {
  id: number;
  name: string;
  code: string;
}

const TOKEN_KEY = "X-Auth-Token";

export enum LeadStatus {
  PENDING_CONTACT = "未处理",
  UNREACHABLE = "待跟进",
  //NO_DEMAND = "待跟进",
  OUT_LEAD = "外地客户",
  NON_COMPLIANCE = "资质不符",
  INVITATION_IN_PROGRESS = "邀约中",
  PENDING_VISIT = "待上门",
  VISITED = "已上门",
  // PENDING_CONTRACT = "待签约",
  SIGNED_CONTRACT = "已签约",
  //REVIEWING = "审核中",
  // PAY_OUT = "已放款",
  //REJECTED = "银行拒绝",
  //DEPOSIT_PAID = "定金转回款",
  PAID = "已回款",
}

export enum LeadType {
  NEW = "我的客户",
  MY = "再分配客户",
  FAV = "重要客户",
  POOL = "公共池客户",
  WASTE = "废物池客户",
  CANCELLATION = "退单客户",
  //PAID = "回款客户",
}

export const SalesLeadLeadStatus = [
  LeadStatus.PENDING_CONTACT,
  LeadStatus.UNREACHABLE,
  LeadStatus.OUT_LEAD,
  LeadStatus.PENDING_VISIT,
  LeadStatus.VISITED,
  LeadStatus.SIGNED_CONTRACT,
];

export const ReadOnlyLeadStatus = [LeadStatus.PAID];

export const ReadOnlyVisitLeadStatus = [
  LeadStatus.PENDING_CONTACT,
  LeadStatus.UNREACHABLE,
  LeadStatus.OUT_LEAD,
  LeadStatus.PENDING_VISIT,
];

export enum LeadAssignStatus {
  NOT_ASSIGNED = "未分配",
  ASSIGNED = "已分配",
  POOL = "公共池",
  WASTE = "废物池",
}

export enum TrafficAppStatus {
  ENABLED = "已启用",
  DISABLED = "已禁用",
  HIDED = "已隐藏",
}

export enum TeamManagerStatus {
  ENABLED = "已启用",
  DISABLED = "已禁用",
}

export enum TodoStatus {
  B_DONE = "已处理",
  A_UNDO = "未处理",
}

export enum UserStatus {
  ENABLED = "已启用",
  DISABLED = "已禁用",
  LEAVE = "已离职",
}

export enum LoanStatus {
  // REVIEWING = "银行审核中",
  PAY_OUT = "已放款",
  // REJECTED = "审核拒绝",
  // DEPOSIT_PAID = "定金转回款",
  PAID = "已回款",
}

export enum MortgageLoanStatus {
  HKZ = "还款中",
  YQ = "已逾期",
  YJQ = "已结清",
  VR_YHZ = "已坏账",
}

export enum RepaymentPlanStatus {
  HKZ = "还款中",
  YJQ = "已还款",
  YQ = "已逾期",
  PENDING = "待审核",
  REJECTED = "已驳回",
  EDIT = "编辑中",
  CANCEL = "取消中",
  VR_YGZ = "已过账",
  VR_YJQ = "已结清",
  VR_YHZ = "已坏账",

}


export enum PaidMethod {
  DH="代还",KHZH="客户自还",
  M_HK_DH="信贷代还还款",M_HK_ZH="信贷自还还款",M_JQ_DH="信贷代还结清",M_JQ_ZH="信贷自还结清",
  C_HK_DH="信用卡代还还款",C_GZ_DH="信用卡代还过账",C_JQ_DH="信用卡代还结清",C_HK_ZH="信用卡自还还款",C_GZ_ZH="信用卡自还过账",C_JQ_ZH="信用卡自还结清",
  B_HK_ZH="借款自还还款",B_JQ_ZH="借款自还结清"
}

export enum MortgageLoanType {
  MORTGAGE = "信贷客户",
  CARD = "信用卡客户",
  BORROW= "个人借款"

}

export enum LoanAuditingStatus {
  NOT_AUDITING = "待确认",
  AUDITING = "已确认",
}

export const StarTimes = [
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
];
export const EndTimes = [
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
];

export const ReadOnlyLoanStatus = [
  //LoanStatus.DEPOSIT_PAID,
  LoanStatus.PAID,
  //LoanStatus.REJECTED
];

export function displayLeadStatus(status: string | number) {
  let value = (LeadStatus as any)[status];
  return value || status;
}

export function phoneHide(phone: string) {
  let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
  phone = phone.replace(reg, "$1****$2");
  return phone; // 输出为131****1234
}

export function displayLeadType(leadType: string | number) {
  let value = (LeadType as any)[leadType];
  return value || leadType;
}

export function displayLoanStatus(status: string) {
  let value = (LoanStatus as any)[status];
  return value || status;
}

export function displayLoanAuditingStatus(auditingStatus: string) {
  let value = (LoanAuditingStatus as any)[auditingStatus];
  return value || auditingStatus;
}

export function displayLeadAssignStatus(status: string) {
  let value = (LeadAssignStatus as any)[status];
  return value || status;
}

export function displayUserStatus(status: string) {
  let value = (UserStatus as any)[status];
  return value || status;
}

export function displayTrafficAppStatus(status: string) {
  let value = (TrafficAppStatus as any)[status];
  return value || status;
}

export function displayRepaymentPlanStatus(status: string) {
  let value = (RepaymentPlanStatus as any)[status];
  return value || status;
}
export function displayPaidMethod(status: string) {
  let value = (PaidMethod as any)[status];
  return value || status;
}

export function displayMortgageLoanStatus(status: string) {
  let value = (MortgageLoanStatus as any)[status];
  return value || status;
}

export function displayTeamManagerStatus(status: string) {
  let value = (TeamManagerStatus as any)[status];
  return value || status;
}

export function displayTodoStatus(status: string) {
  let value = (TodoStatus as any)[status];
  return value || status;
}

export function getLeadStatusOpt(): CrudOption[] {
  //城市不是成都和兰州的，去除状态 邀约中
  let city = localStorage.getItem("city");
  if (city && city !== "成都" && city !== "兰州") {
    return Object.keys(LeadStatus).filter(k=>k!="INVITATION_IN_PROGRESS").map((k) => {
      return {
        label: (LeadStatus as any)[k],
        value: k,
        key: k,
      };
    });
  }
  return Object.keys(LeadStatus).map((k) => {
    return {
      label: (LeadStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getLeadTypeOpt(): CrudOption[] {
  return Object.keys(LeadType).map((k) => {
    return {
      label: (LeadType as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getSalesLeadStatusOpt(): CrudOption[] {
  //城市不是成都和兰州的，去除状态 邀约中
  let city = localStorage.getItem("city");
  if (city && city !== "成都" && city !== "兰州") {
    return Object.keys(LeadStatus).filter(k=>k!="INVITATION_IN_PROGRESS").map((k) => {
      let label = (LeadStatus as any)[k];
      return {
        label: label,
        value: k,
        key: k,
        disabled: !SalesLeadLeadStatus.includes(label),
      };
    });
  }

  return Object.keys(LeadStatus).map((k) => {
    let label = (LeadStatus as any)[k];
    return {
      label: label,
      value: k,
      key: k,
      disabled: !SalesLeadLeadStatus.includes(label),
    };
  });
}

export function getLeadAssignStatusOpt(): CrudOption[] {
  return Object.keys(LeadAssignStatus).map((k) => {
    return {
      label: (LeadAssignStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getLoanStatusOpt(): CrudOption[] {
  return Object.keys(LoanStatus).map((k) => {
    return {
      label: (LoanStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getLoanAuditingStatusOpt(): CrudOption[] {
  return Object.keys(LoanAuditingStatus).map((k) => {
    return {
      label: (LoanAuditingStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getUserStatusOpt(): CrudOption[] {
  return Object.keys(UserStatus)
    .filter((k) => k != "LEAVE" && k != "DISABLED")
    .map((k) => {
      return {
        label: (UserStatus as any)[k],
        value: k,
        key: k,
      };
    });
}

export function getTrafficAppStatusOpt(): CrudOption[] {
  return Object.keys(TrafficAppStatus).map((k) => {
    return {
      label: (TrafficAppStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getMortgageLoanStatusOpt(): CrudOption[] {
  return Object.keys(MortgageLoanStatus).map((k) => {
    return {
      label: (MortgageLoanStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getRepaymentPlanStatusOpt(): CrudOption[] {
  return Object.keys(RepaymentPlanStatus).map((k) => {
    return {
      label: (RepaymentPlanStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getPaidMethodOpt(): CrudOption[] {
  return Object.keys(PaidMethod).map((k) => {
    return {
      label: (PaidMethod as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getTeamManagerStatusOpt(): CrudOption[] {
  return Object.keys(TeamManagerStatus).map((k) => {
    return {
      label: (TeamManagerStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export function getTodoStatusOpt(): CrudOption[] {
  return Object.keys(TodoStatus).map((k) => {
    return {
      label: (TodoStatus as any)[k],
      value: k,
      key: k,
    };
  });
}

export class ApiClient {
  endpoint: string;
  toastId: string | null = "";
  confirmId: string | null = "";
  static API_CLIENT = new ApiClient(getEndpoint());

  static getDefault() {
    return this.API_CLIENT;
  }

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  getEndpoint() {
    return this.endpoint;
  }

  private getUrl(path: String, params?: Record<string, string> | null): string {
    let urlParams = params
      ? `?${new URLSearchParams(filterObj(params)).toString()}`
      : "";
    return `${this.endpoint}${path}${urlParams}`;
  }

  private getHeader(): Record<string, string> {
    let headers: Record<string, string> = {};
    let token = this.getToken();
    if (token) {
      headers[TOKEN_KEY] = token;
    }
    return headers;
  }

  async request<T>(
    path: String,
    method: string,
    params?: Record<string, any> | null,
    dto?: Req | FormData | null,
    file?: File | null
  ): Promise<ApiResp<T>> {
    let url = this.getUrl(path, params);
    let headers: Record<string, string> = this.getHeader();

    let fetchParam: RequestInit = {
      headers: headers,
      method: method,
    };
    if (dto) {
      if (dto instanceof FormData) {
        // FormData 直接作为 body，浏览器会自动设置 multipart/form-data; boundary=...
        fetchParam.body = dto;
      } else {
        headers["Content-Type"] = "application/json";
        fetchParam.body = JSON.stringify(dto);
      }
    }
    if (file) {
      let formData = new FormData();
      formData.append("file", file);
      fetchParam.body = formData;
    }
    try {
      let resp = await fetch(url, fetchParam);
      let apiResp = (await resp.json()) as ApiResp<T>;
      if (!resp.ok || apiResp.code != "ok") {
        throw {
          name: apiResp.code,
          message: apiResp.msg,
        };
       
      }
      return apiResp;
    } catch (e) {
      this.handleError(e as Error);
      throw e;
    }
  }

  private handleError(e: Error) {
     //忽略一些错误
     if (e.name == "not_allowed" || e.message == "Failed to fetch") {
      return;
    }
     else if (e.name == "401-offline" || e.name == "401-expired" ) {
      this.toLogin();
    }else{
        Toast.error({
          content: e.message,
          duration: 5,
         
        });
 
    }
   
  }

  toLogin() {
    //获取浏览器访问的IP
    let ip = window.location.host;
    if("47.109.154.206" == ip){
      window.location.href = "/#/login";
    }else{
      window.location.href = "/#/login";
    }
    
  };

  async logIn(dto: LogInReq): Promise<ApiResp<String>> {
    return this.request("/auth/authWithPassword", "POST", undefined, dto);
  }

  async logInSms(dto: LogInReq): Promise<ApiResp<String>> {
    return this.request("/auth/loginByCaptcha", "POST", undefined, dto);
  }

  async switchAccountLogIn(dto: SwitchLogInReq): Promise<ApiResp<String>> {
    return this.request("/auth/switchAccountAuth", "POST", undefined, dto);
  }

  async fetchToken(): Promise<ApiResp<string>> {
    return this.request("/auth/token", "GET");
  }

  async logout(): Promise<ApiResp<boolean>> {
    return this.request("/auth/logout", "POST");
  }

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  getAttachmentUploadUrl(loanId: number): string {
    return this.getUrl("/loans/attachment/" + loanId);
  }

  getAttachmentFieldUploadUrl(field: string, loanId: number): string {
    return this.getUrl("/loans/attachment/" + field + "/" + loanId);
  }

  getAttachmentLocalFieldUploadUrl(field: string, loanId: number): string {
    return this.getUrl("/attachmentLocal/upload/" + field + "/" + loanId);
  }
  getAttachmentLocalDownUrl(fileId: string): string {
    return this.getUrl("/attachmentLocal/" + fileId);
  }

  getUploadUrl(): string {
    return this.getUrl("/file");
  }

  setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  async initToken() {
    if (!this.getToken()) {
      let token = await this.fetchToken();
      this.setToken(token.data);
    }
  }

  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  }

  async getCurrentAdmin(): Promise<ApiResp<User>> {
    return this.request<User>("/auth/user", "GET");
  }

  async getAppVersion(): Promise<ApiResp<AppVersion>> {
    return this.request<AppVersion>("/attachment/app/getVersion", "GET");
  }

  async getCaptchaImage(): Promise<string> {
    let url = this.getUrl("/auth/captcha");
    let fetchParam: RequestInit = {
      headers: this.getHeader(),
      method: "GET",
    };
    try {
      let resp = await fetch(url, fetchParam);
      let blob = await resp.blob();
      return URL.createObjectURL(blob);
    } catch (e) {
      //this.handleError(e as Error);
      throw e;
    }
  }

  /**
   * 以带 X-Auth-Token 的方式下载二进制文件，返回浏览器可用的 blob: URL。
   * 用于需要鉴权的文件下载（避免 window.open 丢失 header 导致 401 not_allowed）。
   * 调用方拿到 URL 后用 <a download> 触发保存。
   */
  async downloadBlobUrl(
    path: string,
    params?: Record<string, any> | null
  ): Promise<string> {
    let url = this.getUrl(path, params);
    let resp = await fetch(url, {
      headers: this.getHeader(),
      method: "GET",
    });
    if (!resp.ok) {
      let msg = `下载失败 (${resp.status})`;
      try {
        const body = await resp.json();
        if (body?.msg) msg = body.msg;
      } catch (_) { /* ignore */ }
      throw new Error(msg);
    }
    let blob = await resp.blob();
    return URL.createObjectURL(blob);
  }

  async batchCreateBookWithExcel(file: File) {
    return this.request<number>("/book/excel", "POST", null, null, file);
  }

  async getBookExcelUrk() {
    return this.request<string>("/book/excelTemplateUrl", "GET");
  }

  async getSiteInfo(): Promise<ApiResp<SiteInfo>> {
    return this.request<SiteInfo>("/siteInfo", "GET");
  }

  async getApiDocInfo(): Promise<ApiResp<ApiDocInfo>> {
    return this.request<ApiDocInfo>("/siteInfo/apiDocInfo", "GET");
  }

  async getAllRoles(): Promise<ApiResp<Page<Role>>> {
    return this.request<Page<Role>>("/roles", "GET", {
      page: 1,
      size: 10000,
    });
  }

  async getClientConfig(clientType: string): Promise<ApiResp<ClientConfig>> {
    return this.request<ClientConfig>("/config/clientConfig", "GET", {
      clientType,
    });
  }

  async updateClientConfig(configs: UpdateConfig[]): Promise<ApiResp<boolean>> {
    return this.request<boolean>("/config/clientConfig", "PUT", null, {
      configs,
    });
  }

  async getPaymentClients(): Promise<ApiResp<PayClient>> {
    return this.request<PayClient>("/payClient", "GET");
  }

  async closeOrderByLoanId(loanId: number): Promise<ApiResp<Boolean>> {
    return this.request<Boolean>("/order/closeByLoanId/" + loanId, "POST");
  }

  async closeOrderById(orderId: number): Promise<ApiResp<Boolean>> {
    return this.request<Boolean>("/order/close/" + orderId, "POST");
  }

  async createOrder(dto: any): Promise<ApiResp<any>> {
    return this.request<any>("/order", "POST", null, dto);
  }

  async updateUserInfo(dto: any): Promise<ApiResp<any>> {
    return this.request<any>("/userInfo", "PUT", null, dto);
  }

  async updateLoan(dto: any): Promise<ApiResp<any>> {
    return this.request<any>("/loan", "PUT", null, dto);
  }

  async getEnums(): Promise<ApiResp<Record<string, string[]>>> {
    return this.request<any>("/enum", "GET");
  }

  async getAllCsAgent(): Promise<CsAgent[]> {
    let resp = await this.request<Page<CsAgent>>("/csAgent", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records;
  }

  async updateCsAgent(userIds: any, csAgentId: any): Promise<ApiResp<CsAgent>> {
    return this.request<User>("/userLoan/cs", "POST", null, {
      userIds: userIds,
      csAgentId: csAgentId,
    });
  }

  async getUserLoanStat(
    page: number,
    size: number
  ): Promise<UserLoanStatItem[]> {
    let resp = await this.request<Page<UserLoanStatItem>>(
      "/userLoanStat",
      "GET",
      {
        page: page,
        size: size,
      }
    );
    return resp.data.records;
  }

  async getCsStat(page: number, size: number): Promise<CsStatItem[]> {
    let resp = await this.request<Page<CsStatItem>>("/csStat", "GET", {
      page: page,
      size: size,
    });
    return resp.data.records;
  }

  async getRecentInputs(type: string): Promise<string[]> {
    let resp = await this.request<RecentInputResult>("/recentInput", "GET", {
      type: type,
    });
    return resp.data.inputs;
  }

  async cal(amount: number, term: number, apr: number): Promise<CalResp> {
    let resp = await this.request<CalResp>("/loan/cal", "POST", null, {
      amount,
      term,
      apr,
    });
    return resp.data;
  }

  async getDict(code: string): Promise<string[]> {
    let cached = DICT[code];
    if (cached) {
      return cached;
    }
    let resp = await this.request<string[]>("/dicts/" + code, "GET");
    DICT[code] = resp.data;
    return resp.data;
  }

  /**
   * 批量获取多个字典编码的字典值。
   * 一次请求获取多个字典，减少请求数量。
   * 获取结果会自动填充到本地缓存。
   *
   * @param codes 字典编码列表
   * @returns key=字典编码, value=字典值列表
   */
  async getDictBatch(codes: string[]): Promise<Record<string, string[]>> {
    let resp = await this.request<Record<string, string[]>>("/dicts/batch", "POST", undefined, codes);
    // 将结果填充到本地缓存
    if (resp.data) {
      for (const [code, items] of Object.entries(resp.data)) {
        DICT[code] = items;
      }
    }
    return resp.data;
  }

  async getDictAsOpts(code: string): Promise<CrudOption[]> {
    let role = localStorage.getItem("role");
    let city = localStorage.getItem("city");
    if ((role != "root"&&role != "op_manager"&&role != "source"&&role != "monitor") && city) {
      return [{
        label: city,
        value: city,
        key: city,
      }]
    } else {
      let data = await this.getDict(code);
      return data.map((v) => {
        return {
          label: v,
          value: v,
          key: v,
        };
      });
    }
  }

  /** 解析 V2 字典（支持嵌套格式），返回 CrudOption[] */
  async getDictV2AsOpts(code: string): Promise<CrudOption[]> {
    let data = await this.getDict(code);
    return data.map((v, i) => {
      try {
        const parsed = JSON.parse(v);
        return {
          label: parsed.label,
          value: parsed.label,
          key: parsed.label,
          children: parsed.children ? parsed.children.map((c: string) => ({
            label: c,
            value: parsed.label + "-" + c,
            key: parsed.label + "-" + c,
          })) : undefined,
        };
      } catch {
        return { label: v, value: v, key: v };
      }
    });
  }

  async getSalesAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<User[]>("/users/sales", "GET");
    return resp.data.map((v) => {
      return {
        label: v.name,
        value: v.id + "",
        key: v.id + "",
      };
    });
  }

  async getTeamAgentsAsOpts(dataScope:string): Promise<CrudOption[]> {
    let url="/teams/teamMember";
    if (dataScope) {
      url = url+"?dataScope="+dataScope;
    }
    let resp = await this.request<User[]>(url, "GET");
    let users = resp.data;
    return resp.data.map((v) => {
      return {
        label: v.name,
        labelSubText: v.rootTeamName + " - " + v.teamName,
        value: v.id + "",
        key: v.id + "",
      };
    });
  }

  async getAgentsAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<User[]>("/users/agents", "GET");
    return resp.data.map((v) => {
      return {
        label: v.name,
        labelSubText: v.rootTeamName + " - " + v.teamName,
        value: v.id + "",
        key: v.id + "",
      };
    });
  }

  async getTeamCityAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<User[]>("/teams/teamCitys", "GET");
    return resp.data.map((v) => {
      return {
        label: v.name,
        value: v.id + "",
        key: v.id + "",
      };
    });
  }

  async getRootTeamAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<Team[]>("/teams/teamCitys", "GET");
    return resp.data.map((v) => {
      return {
        label: v.name,
        value: v.id,
        key: v.id + "",
      };
    });
  }

  async getCurrentRootTeamAsOpts(): Promise<CrudOption[]> {
    let role = localStorage.getItem("role");
    let teamId = localStorage.getItem("teamId");
    let teamName = localStorage.getItem("teamName");
    if ((role != "root"&&role != "op_manager"&&role != "source"&&role != "monitor") && teamId) {
      let resp = await this.request<Team>("/teams/findRootTeam?teamId="+teamId, "GET");
      return [{
        label: resp.data.name,
        value: resp.data.id+"",
        key: resp.data.id+"",
      }]
    } else {
    let resp = await this.request<Team[]>("/teams/teamCitys", "GET");
    return resp.data.map((v) => {
      return {
        label: v.name,
        value: v.id,
        key: v.id + "",
      };
    });
  }
  }

  

  async getSalesTreeAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<User[]>("/users/sales", "GET");
    let users = resp.data;
    return users
      .filter((t) => !t.managerId)
      .map((t) => this.buildUserTree(t, users));
  }

  async getTeamMemberTreeAsOpts(username: any): Promise<CrudOption[]> {
    let resp = await this.request<User[]>("/teams/teamMember", "GET");
    let users = resp.data;
    return users
      .filter((t) => t.username == username)
      .map((t) => this.buildUserTree(t, users));
  }

  async getTeamMemberTreeAsOptsOfAny(username: any, dataScope?:string|null|undefined): Promise<any[]> {
    let url="/teams/teamMember";
    if (dataScope) {
      url = url+"?dataScope="+dataScope;
    }
    let resp = await this.request<User[]>(url, "GET");
    let users = resp.data;
    if (username == "") {
      return users.map((t) => this.buildUserTreeOfAny(t, users));
    } else {
      return users
        .filter((t) => t.username == username)
        .map((t) => this.buildUserTreeOfAny(t, users));
    }
  }

  async getUsersTreeAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<User[]>("/users/allUsers", "GET");
    let users = resp.data;
    return users
      .filter((t) => !t.managerId)
      .map((t) => this.buildUserTree(t, users));
  }

  buildUserTree(user: User, users: User[]): CrudOption {
    return {
      key: user.id + "",
      label: user.name,
      value: user.id + "",
      children: users
        .filter((t) => {
          return t.managerId == user.id;
        })
        .map((t) => this.buildUserTree(t, users)),
    };
  }

  buildUserTreeOfAny(user: User, users: User[]): any {
    // if (users != null && users.length > 0) {
    //   const children = users
    //     .filter((t) => {
    //       return t.managerId == user.id;
    //     })
    //     .map((t) => this.buildUserTree(t, users));

    //   children.unshift({
    //     key: user.id + "" + Math.random() * 100000,
    //     label: user.name,
    //     value: user.id + "",
    //     children: [],
    //   });

    //   return {
    //     key: user.id + "",
    //     label: user.teamName + "（" + user.name+ "）",
    //     value: user.id + "" + Math.random() * 100000,
    //     children: children,
    //   };
    // } else {
    return {
      key: user.id + "",
      //label: user.name + "（" + user.teamName + "-"+user.city+"）",
      label: user.name ,
      labelSubText: user.teamName+ " "+ user.roleName ,
      value: user.id + "",
      teamId:user.teamId,
      mobile:user.mobile,
      children: users
        .filter((t) => {
          return t.managerId == user.id;
        }).sort((a, b) => a.teamName.localeCompare(b.teamName))
        .map((t) => this.buildUserTreeOfAny(t, users)),
    };
    // }
  }

  async getSourceAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<TrafficApp[]>(
      "/trafficApps/allTrafficApps",
      "GET"
    );
    return resp.data.map((v) => {
      return {
        label: v.name,
        value: v.id + "",
        key: v.id + "",
      };
    });
  }

  async getSourceNameCodeAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<TrafficApp[]>(
      "/trafficApps/allTrafficApps",
      "GET"
    );
    return resp.data.map((v) => {
      return {
        label: v.code,
        value: v.code,
        key: v.code,
      };
    });
  }

  async getSourceNameCodeNewAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<TrafficApp[]>(
      "/trafficApps/allTrafficApps",
      "GET"
    );
    return resp.data.map((v) => {
      return {
        label: v.name,
        value: v.code,
        key: v.code,
      };
    });
  }

  async getTeamAsOpts(): Promise<CrudOption[]> {
    let teams = await this.getAllTeams();
    return teams
      .filter((t) => !t.parentId)
      .map((t) => this.buildTree(t, teams));
  }

  async getAllTeamAsOpts(): Promise<CrudOption[]> {
    let teams = await this.getAllTeamsNoPrivilege();
    return teams
      .filter((t) => !t.parentId)
      .map((t) => this.buildTree(t, teams));
  }

  async getUserAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<any>("/users", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records.map((v: any) => {
      return {
        label: v.name,
        value: v.id,
      };
    });
  }

  async getPayoutLeadAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<any>("/mortgageLoan/getPayoutUsers", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records.map((v: any) => {
      return {
        label: v.name,
        value: v.id,
      };
    });
  }

  async getTeamMemberAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<any>("/teams/teamMember", "GET");
    return resp.data.map((v: any) => {
      return {
        label: v.name,
        value: v.id,
      };
    });
  }

  async getTeamMemberByDataScopeAsOpts(dataScope?:string|null|undefined): Promise<CrudOption[]> {
    let url="/teams/teamMember";
    if (dataScope) {
      url = url+"?dataScope="+dataScope;
    }
    let resp = await this.request<any>(url, "GET");
    return resp.data.map((v: any) => {
      return {
        label: v.name,
        value: v.id,
        city: v.city,
        teamName: v.teamName
      };
    });
  }

  async getProductsAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<any>("/products", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records.map((v: any) => {
      return {
        label: v.name,
        value: v.id,
      };
    });
  }

  async getAllTeams(): Promise<Team[]> {
    let resp = await this.request<Page<Team>>("/teams", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records;
  }

  async getAllTeamsNoPrivilege(): Promise<Team[]> {
    let resp = await this.request<Page<Team>>("/teams/allTeams", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records;
  }

  async getRootTeams(): Promise<Team[]> {
    let resp = await this.request<Page<Team>>("/teams/rootTeams", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records;
  }

  async getAllLeadContactLogs(leadId: number): Promise<LeadContactLog[]> {
    let resp = await this.request<Page<LeadContactLog>>(
      "/leads/contactLog/" + leadId,
      "GET",
      {
        page: 1,
        size: 9999,
      }
    );
    return resp.data.records;
  }

  async getAllLeadContactLogsGroupBySaleId(leadId: number): Promise<LeadContactLog[]> {
    let resp = await this.request<any>(
      "/leads/contactLogGroupBySaleId/" + leadId,
      "GET",

    );
    return resp.data;
  }

  async getLoanTodoUserId(leadId: number): Promise<LeadContactLog[]> {
    let resp = await this.request<any>(
      "/leadLoans/todoUserId/" + leadId,
      "GET",

    );
    return resp.data;
  }

  async getLoanReplyTodoUserId(todoId: number): Promise<LeadContactLog[]> {
    let resp = await this.request<any>(
      "/leadLoans/replyTodoUserId/" + todoId,
      "GET",

    );
    return resp.data;
  }

  async getAllLoanLogs(loanId: number): Promise<LoanLog[]> {
    let resp = await this.request<Page<LoanLog>>(
      "/loans/statusLog/" + loanId,
      "GET",
      {
        page: 1,
        size: 9999,
      }
    );
    return resp.data.records;
  }

  async getAllLoanContactLogs(leadId: number): Promise<LoanContactLog[]> {
    let resp = await this.request<Page<LoanContactLog>>(
      "/leadLoans/contactLog/" + leadId,
      "GET",
      {
        page: 1,
        size: 9999,
      }
    );
    return resp.data.records;
  }

  async auditingLoan(loanId: number): Promise<ApiResp<any>> {
    let resp = await this.request<Page<LoanLog>>(
      "/loans/auditing/" + loanId,
      "PUT"
    );
    return resp;
  }

  async getAllLeadAssignLogs(leadId: number): Promise<LeadAssignLog[]> {
    let resp = await this.request<Page<LeadAssignLog>>(
      "/leads/assignLog/" + leadId,
      "GET",
      {
        page: 1,
        size: 9999,
      }
    );
    return resp.data.records;
  }

  async getAllLeadStarLogs(leadId: number): Promise<LeadStarLog[]> {
    let resp = await this.request<Page<LeadStarLog>>(
      "/leads/starLog/" + leadId,
      "GET",
      {
        page: 1,
        size: 9999,
      }
    );
    return resp.data.records;
  }

  async getAllLeadVisitAssignLogs(
    leadId: number
  ): Promise<LeadVisitAssignLog[]> {
    let resp = await this.request<Page<LeadVisitAssignLog>>(
      "/leadVisitSignLog",
      "GET",
      {
        page: 1,
        size: 9999,
        leadId: leadId,
      }
    );
    return resp.data.records;
  }

  async getAllLeadLoans(leadId: number): Promise<Loan[]> {
    let resp = await this.request<Page<Loan>>("/leads/loan/" + leadId, "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.records;
  }

  async getTeam(id: number): Promise<Team> {
    let resp = await this.request<Team>("/teams/" + id, "GET");
    return resp.data;
  }

  buildTree(team: Team, teams: Team[]): CrudOption {
    return {
      key: team.id + "",
      label: team.name,
      value: team.id + "",
      labelExt: team.userNames,
      children: teams
        .filter((t) => {
          return t.parentId == team.id;
        })
        .map((t) => this.buildTree(t, teams)),
    };
  }

  async getSignedContractLeadsAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<Lead[]>("/leads/signedContract", "GET", {
      page: 1,
      size: 9999,
    });
    return resp.data.map((l) => {
      const parts = [
        l.name,
        l.loanType,
        l.applyAmount + "元",
        l.signedContractAt,
      ];
      return {
        label: parts.join(" / "),
        key: l.id + "",
        value: l.id + "",
      };
    });
  }

  async getLoanAttachments(loanId: number): Promise<FileItem[]> {
    let resp = await this.request<Attachment[]>(
      "/loans/attachment/" + loanId,
      "GET"
    );
    return resp.data.map((a) => {
      return {
        uid: a.id + "",
        status: "success",
        name: a.filename,
        size: bytesToKb(a.size),
        response: a.field,
      };
    });
  }

  async getAttachmentLocals(loanId: number): Promise<FileItem[]> {
    let resp = await this.request<Attachment[]>(
      "/attachmentLocal/getList/" + loanId,
      "GET"
    );
    return resp.data.map((a) => {
      return {
        uid: a.id + "",
        status: "success",
        name: a.filename,
        size: bytesToKb(a.size),
        response: a.field,
      };
    });
  }

  async deleteAttachments(loanId: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>(
      "/attachment/delete/" + loanId,
      "DELETE"
    );
  }

  async deleteAttachmentLocal(fileId: string): Promise<ApiResp<boolean>> {
    return await this.request<boolean>("/attachmentLocal/" + fileId, "DELETE");
  }

  async uploadLoanAttachment(loanId: number, file: File): Promise<FileItem> {
    let resp = await this.request<Attachment>(
      "/loans/attachment/" + loanId,
      "POST",
      null,
      null,
      file
    );
    let attachment = resp.data;
    return {
      uid: attachment.id + "",
      status: "success",
      name: attachment.filename,
      size: bytesToKb(attachment.size),
    };
  }

  async getAttachmentUrl(attachmentId: number): Promise<string> {
    let resp = await this.request<string>(
      "/loans/attachmentUrl/" + attachmentId,
      "GET"
    );
    return resp.data;
  }

  async findLeadByMobile(mobile: string): Promise<Lead> {
    let resp = await this.request<Page<Lead>>("/leads", "GET", {
      mobile: mobile,
      page: 1,
      size: 1,
      type: "all",
    });
    return resp.data.records[0];
  }

  async findLeadByName(name: string): Promise<Lead> {
    let resp = await this.request<Page<Lead>>("/leads", "GET", {
      name: name,
      page: 1,
      size: 1,
      type: "all",
    });
    return resp.data.records[0];
  }

  async findLeadByNameAndMobile(
    id:number,
    name: string,
    mobile: string,
    city: string | null,
  ): Promise<ApiResp<Page<Lead>>> {
    let resp = await this.request<Page<Lead>>("/leads", "GET", {
      id:id,
      name: name,
      mobile: mobile,
      applyCity: city,
      page: 1,
      size: 10,
      type: "all",
    });
    return resp;
  }

  /**
   * 全库模糊搜索客户：仅按关键词在 name + full_mobile 上 OR LIKE。
   * monitor 角色传入 applyCity 做城市过滤，其它角色不传。
   * 支持按 ID 精确查询：传入 id 参数时忽略 keyword。
   */
  async searchAllLeads(
    keyword: string,
    page: number = 1,
    size: number = 50,
    applyCity: string | null = null,
    id?: number | null,
  ): Promise<ApiResp<Page<Lead>>> {
    const params: Record<string, any> = {
      applyCity: applyCity,
      page: page,
      size: size,
      type: "all",
    };
    if (id) {
      params.id = id;
    } else {
      params.name = keyword;
    }
    let resp = await this.request<Page<Lead>>("/leads", "GET", params);
    return resp;
  }

  // ============ 客户触达分析 ============

  async getCustomerTouchStat(
    req: CustomerTouchStatReq,
  ): Promise<ApiResp<CustomerTouchStatVO>> {
    return this.request<CustomerTouchStatVO>(
      "/customerTouchStat",
      "GET",
      buildCustomerTouchParams(req),
    );
  }

  async getCustomerTouchDetail(
    req: CustomerTouchStatReq,
    page: number,
    size: number,
  ): Promise<ApiResp<Page<CustomerTouchDetailVO>>> {
    return this.request<Page<CustomerTouchDetailVO>>(
      "/customerTouchStat/detail",
      "GET",
      { ...buildCustomerTouchParams(req), page, size },
    );
  }

  async getCustomerTouchCallLogs(
    leadId: number,
    saleId: number | null,
    req: CustomerTouchStatReq,
    page: number,
    size: number,
    connected?: boolean | null,
  ): Promise<ApiResp<Page<LeadCallLogItem>>> {
    // 下钻按 leadId+saleId 定位，只传权限/日期相关参数（teamId/customerType 后端 SQL 未使用）
    const params: Record<string, any> = {
      leadId,
      saleId,
      page,
      size,
    };
    if (req.callAtStart && req.callAtEnd) {
      params.callAt = `${req.callAtStart},${req.callAtEnd}`;
    }
    if (req.saleIds && req.saleIds.length > 0) params.saleIds = req.saleIds;
    if (connected != null) params.connected = connected;
    return this.request<Page<LeadCallLogItem>>(
      "/customerTouchStat/callLogs",
      "GET",
      params,
    );
  }

  async getCallStat(
    callAtStart: string,
    callAtEnd: string,
    saleIds?: number[] | null,
  ): Promise<ApiResp<{ rows: CallStatRow[]; summary: CallStatRow }>> {
    const params: Record<string, any> = { callAt: `${callAtStart},${callAtEnd}` };
    if (saleIds && saleIds.length > 0) params.saleIds = saleIds;
    return this.request<{ rows: CallStatRow[]; summary: CallStatRow }>("/callStat", "GET", params);
  }

  async getCustomerTouchDetailExportUrl(
    req: CustomerTouchStatReq,
  ): Promise<string> {
    const params = new URLSearchParams();
    for (const [k, v] of Object.entries(buildCustomerTouchParams(req))) {
      if (v == null || v === "") continue;
      if (Array.isArray(v)) {
        v.forEach((x) => params.append(k, String(x)));
      } else {
        params.set(k, String(v));
      }
    }
    return `/api/mis/customerTouchStat/detail/export?${params.toString()}`;
  }


  async getLead(leadId: number): Promise<Lead> {
    let resp = await this.request<Lead>("/leads/" + leadId, "GET");
    return resp.data;
  }

  async getBadges(): Promise<Record<string, number>> {
    let resp = await this.request<Record<string, number>>("/badge", "GET");
    return resp.data;
  }

  async getMyTeamManagers(): Promise<TeamManager[]> {
    let resp = await this.request<TeamManager[]>("/teamManagers/myTeamManagers", "GET");
    return resp.data;
  }

  async getTodoCount(): Promise<number> {
    let resp = await this.request<number>("/todos/todoCount", "GET");
    return resp.data;
  }
  async getTodoLoanCount(): Promise<number> {
    let resp = await this.request<number>("/todos/todoLoanCount", "GET");
    return resp.data;
  }

  async deleteTodo(todoId: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>("/todos/" + todoId, "DELETE");
  }

  async deleteLoanTodo(todoId: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>("/todos/loanTodo/" + todoId, "DELETE");
  }

  async updateLoanTodoDone(todoId: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>("/leadLoans/updateTodoDone", "POST", null, {
      id: todoId
    });
  }

  async clearBadge(key: string): Promise<boolean> {
    let resp = await this.request<boolean>("/badge/clear/" + key, "POST");
    return resp.data;
  }

  getPref<T>(key: string): T | undefined {
    const json = localStorage.getItem(PREF_KEY);
    if (json === null) {
      return undefined;
    }
    return JSON.parse(json)[key];
  }

  putPref<T>(key: string, value: any) {
    let json = localStorage.getItem(PREF_KEY);
    if (json === null) {
      json = "{}";
    }
    let pref = JSON.parse(json);
    pref[key] = value;
    localStorage.setItem(PREF_KEY, JSON.stringify(pref));
  }

  getWsClient(routes: Record<string, messageCallbackType>): Client {
    const client = new Client({
      brokerURL: getWsEndpoint(),
      onConnect: () => {
        Object.keys(routes).forEach((k) => {
          client.subscribe(k, routes[k]);
        });
      },
    });
    return client;
  }

  async getAllTodos() {
    let resp = await this.request<Page<Todo>>("/todos", "GET", {
      page: 1,
      size: 9999,
      type: "all",
    });
    return resp.data.records;
  }

  async getUserStat(data:any): Promise<ApiResp<any>> {
    return this.request("/users/userStat", "GET", data);
  }

  async getTeamUserStat(data:any): Promise<ApiResp<any>> {
    return this.request("/teamMember/teamUserStat", "GET", data);
  }

  async getUserProfile(id: number): Promise<ApiResp<any>> {
    return this.request(`/users/${id}/profile`, "GET");
  }

  async assignNotContactLeadCount(data: any): Promise<ApiResp<any>> {
    return this.request("/leads/assignNotContactLeadCount", "GET", data);
  }

  async assignNotContactMyLeadCount(data: any): Promise<ApiResp<any>> {
    return this.request("/leads/assignNotContactMyLeadCount", "GET", data);
  }

  async deleteLead(leadId: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>("/leads/" + leadId, "DELETE");
  }

  async deleteTrafficApp(id: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>(
      "/trafficApps/delete/" + id,
      "DELETE"
    );
  }

  async deleteMortgageLoan(id: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>(
        "/mortgageLoan/delete/" + id,
        "DELETE"
    );
  }


  async makeRepaymentPlan(id: number): Promise<ApiResp<boolean>> {
    return await this.request<boolean>(
        "/mortgageLoan/makePlan/" + id,
        "POST"
    );
  }

  async getCacheValue(key:any): Promise<ApiResp<any>> {
    return this.request("/redisManagers/get/"+key, "GET");
  }

  async deleteCacheGroupByKey(key:any): Promise<ApiResp<any>> {
    return this.request("/redisGroupManagers/delete/"+key, "DELETE");
  }

  async deleteCacheByKey(key:any): Promise<ApiResp<any>> {
    return this.request("/redisManagers/delete/"+key, "DELETE");
  }

  async updateCacheValue(key: string, value: string, expire: number): Promise<ApiResp<boolean>> {
    return this.request("/redisManagers/update", "PUT", undefined, { key, value, expire });
  }

  async getCacheSwitchOn(): Promise<ApiResp<any>> {
    return this.request("/redisGroupManagers/getCacheSwitchOn", "GET");
  }

  async setCacheSwitchOn(): Promise<ApiResp<any>> {
    return this.request("/redisGroupManagers/setCacheSwitchOn/", "POST");
  }

  async getScheduledTasks(): Promise<ApiResp<any[]>> {
    return this.request("/scheduled-tasks", "GET");
  }

  async toggleScheduledTask(taskCode: string, enabled: boolean): Promise<ApiResp<boolean>> {
    return this.request("/scheduled-tasks/" + taskCode + "/toggle", "PUT", null, { enabled });
  }

  async triggerScheduledTask(taskCode: string): Promise<ApiResp<boolean>> {
    return this.request("/scheduled-tasks/" + taskCode + "/trigger", "POST");
  }

  async getScheduledTaskDetail(taskCode: string): Promise<ApiResp<any>> {
    return this.request("/scheduled-tasks/" + taskCode, "GET");
  }

  async getBankEntCityAsOpts(): Promise<CrudOption[]> {
    let resp = await this.request<string[]>("/bankTrustEnterprise/citySelect", "GET");
    return resp.data.map((v) => {
      return {
        label: v,
        value: v,
        key: v,
      };
    });
  }


}

export function getLeadStatItemOpt(): CrudOption[] {
  let items = [
    {
      label: "今日入库总数",
      value: "statToday",
      key: "0",
    },
    {
      label: "今日入库0星数",
      value: "statToday0",
      key: "1",
    },
    {
      label: "近3日入库总数",
      value: "statThreeDay",
      key: "2",
    },
    {
      label: "近3日入库0星数",
      value: "statThreeDay0",
      key: "3",
    },
    {
      label: "近3日入库>=3星数",
      value: "statThreeDay3",
      key: "4",
    },
    // {
    //   label: "近5日未跟进数",
    //   value: "statSevenDay",
    //   key: "5",
    // },
    // {
    //   label: "近5日未跟进0星数",
    //   value: "statSevenDay0",
    //   key: "6",
    // },
    // {
    //   label: "近5日未跟进>=3星数",
    //   value: "statSevenDay3",
    //   key: "7",
    // },
  ];
  return items;
}

export function getMyLeadStatItemOpt(): CrudOption[] {
  let items = [
    {
      label: "名下总数",
      value: "statMyAll",
      key: "2",
    },
    {
      label: "名下0星数",
      value: "statMyAll0",
      key: "3",
    },
    {
      label: "未跟进总数",
      value: "statMyNotContactAll",
      key: "5",
    },
    {
      label: "未跟进0星数",
      value: "statMyNotContactAll0",
      key: "6",
    },
    {
      label: "未跟进>=3星数",
      value: "statMyNotContactAll3",
      key: "7",
    },
  ];
  return items;
}

export function getLoanTypeItemOpt(): CrudOption[] {
  return Object.keys(MortgageLoanType).map((k) => {
    return {
      label: (MortgageLoanType as any)[k],
      value: k,
      key: k,
    };
  });

}

export function displayMortgageLoanType(type: string) {
  let value = (MortgageLoanType as any)[type];
  return value || type;
}

export function getEndpointUrl(): string {
  return getEndpoint();

}

